import { navigation } from '../../../../styles/colors';
import { SvgIcon } from '../SvgIcon';
import { useState } from 'react';
import * as React from 'react';

interface IProps {
	className?: string;
	fillColor?: string;
	hoverColor?: string;
	size?: number;
}

export const LinkIcon: React.FC<IProps> = props => {
	const { className, fillColor, hoverColor, size } = props;
	const [hover, setHover] = useState(false);
	const onMouseEntered = () => setHover(true);
	const onMouseLeft = () => setHover(false);

	const stroke = (hover ? hoverColor : fillColor) || navigation;

	return (
		<SvgIcon
			onMouseEnter={onMouseEntered}
			onMouseLeave={onMouseLeft}
			className={className || ''}
			width={size || 30}
			height={size || 30}
			viewBox='0 0 512 512'
		>
			<path
				d='M200.66,352H144a96,96,0,0,1,0-192h55.41'
				fill='none'
				stroke={stroke}
				strokeLinecap='square'
				strokeWidth='48px'
				strokeLinejoin='round'
			/>
			<path
				d='M312.59,160H368a96,96,0,0,1,0,192H311.34'
				fill='none'
				stroke={stroke}
				strokeLinecap='square'
				strokeWidth='48px'
				strokeLinejoin='round'
			/>
			<line
				x1='169.07'
				y1='256'
				x2='344.93'
				y2='256'
				fill='none'
				stroke={stroke}
				strokeLinecap='square'
				strokeLinejoin='round'
				strokeWidth='48px'
			/>
		</SvgIcon>
	);
};
